import Header from "@/components/Header";
import AboutSection from "@/components/AboutSection";
import Services from "@/components/Services";
import Zones from "@/components/Zones";
import FAQ from "@/components/FAQ";
import CallButton from "@/components/CallButton";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useState } from "react";
import { Phone, Clock, Shield, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import heroImage from "@/assets/serrurier-hero-new.jpg";
import { CallbackForm } from "@/components/CallbackForm";

const SainteFoy = () => {
  const [callbackOpen, setCallbackOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <SEO 
        title="Serrurier Sainte-Foy-lès-Lyon 24h/7j – Tolstoï Serrurier | Intervention Rapide | 04 82 53 16 08"
        description="Serrurier d'urgence à Sainte-Foy-lès-Lyon : ouverture porte, changement/réparation serrure, porte blindée, volet roulant. Intervention rapide 24h/24 et 7j/7. Devis gratuit."
        keywords="serrurier Sainte-Foy-lès-Lyon, serrurier Sainte-Foy, dépannage serrure Sainte-Foy-lès-Lyon, ouverture porte Sainte-Foy, changement serrure Sainte-Foy-lès-Lyon"
        canonical="https://www.tolstoi-serrurier.fr/sainte-foy-les-lyon"
        ogUrl="https://www.tolstoi-serrurier.fr/sainte-foy-les-lyon"
        ogImage="https://www.tolstoi-serrurier.fr/logo.jpg"
      />
      <Header />
      <main>
        {/* Hero Section Sainte-Foy-lès-Lyon */}
        <section className="relative text-white pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={heroImage} 
              alt="Serrurier professionnel à Sainte-Foy-lès-Lyon" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-black/50" />
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center mb-16">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                Serrurier Sainte-Foy-lès-Lyon
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-white/90">
                Intervention rapide sur toute la commune de Sainte-Foy-lès-Lyon. Dépannage serrurerie, ouverture de porte et sécurisation 24h/7j.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button size="lg" variant="default" className="text-lg px-8 py-6 gap-3" asChild>
                  <a href="tel:0482531608">
                    <Phone className="h-6 w-6" />
                    04 82 53 16 08
                  </a>
                </Button>
                <Button 
                  size="lg" 
                  variant="secondary" 
                  className="text-lg px-8 py-6 gap-3"
                  onClick={() => setCallbackOpen(true)}
                >
                  Demander un rappel
                </Button>
              </div>
            </div>

            <CallbackForm open={callbackOpen} onOpenChange={setCallbackOpen} />

            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
                  <Clock className="h-10 w-10 text-primary" />
                  <h2 className="font-semibold text-lg">Intervention rapide</h2>
                  <p className="text-sm text-white/80">24h/24 et 7j/7</p>
                </div>
                <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
                  <Shield className="h-10 w-10 text-primary" />
                  <h2 className="font-semibold text-lg">Serrurier certifié</h2>
                  <p className="text-sm text-white/80">Professionnel qualifié</p>
                </div>
                <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
                  <Zap className="h-10 w-10 text-primary" />
                  <h2 className="font-semibold text-lg">Devis transparent</h2>
                  <p className="text-sm text-white/80">Sans surprise</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AboutSection 
          location="Sainte-Foy-lès-Lyon" 
          locationContext="à Sainte-Foy-lès-Lyon et dans le Grand Lyon"
        />
        <Services location="Sainte-Foy-lès-Lyon" />
        <Zones />
        <FAQ location="Sainte-Foy-lès-Lyon" />
      </main>
      <Footer />
      <CallButton />
    </div>
  );
};

export default SainteFoy;
